import { render } from "./PartnerBank.vue?vue&type=template&id=27a58c39&scoped=true"
import script from "./PartnerBank.vue?vue&type=script&lang=js"
export * from "./PartnerBank.vue?vue&type=script&lang=js"

import "./PartnerBank.vue?vue&type=style&index=0&id=27a58c39&scoped=true&lang=scss"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a58c39"]])

export default __exports__